import AbstractInterieur from "./AbstractInterieur";

export default class Einlegeboden extends AbstractInterieur {

    constructor(vsData) {
        super(vsData);
        this.tapable = true;
    }

    onDragBegin() {
        super.onDragBegin();
        APP.model.showDoorsClosed(false);
    }

    onDrop() {
        super.onDrop();
        if (!this.vsData.isDropped) {
            this.onTap();
            this.vsData.isDropped = true;
        }
    }

    onTap() {
        if (this.vsData.isOrphaned()) {
            return;
        }

        const bodenFactory = this.vsData.spreadEquallyOverFreeSpaceY();

        if (bodenFactory.maxCount === 0) {
            return;
        }

        APP.uiHandler.sidebar('boden', this);


        // APP.uiHandler.dialog({
        //     title: I18N('dialogEinlegebodenTitle'),//'Einlegeboden',
        //     text: !this.vsData.element.hasEinlegeboden(this) ? I18N('dialogEinlegebodenText') : '',//'Wieviele Einlegeböden möchten Sie einbauen?',
        //     inputs: inputs,
        //     buttons: [
        //         {
        //             style: 'primary',
        //             label: I18N('OK'),
        //             click: input => {
        //                 let choiceCount = this.vsData.element.hasEinlegeboden(this)
        //                     ? 1
        //                     : parseInt(input.radio('faecher'),10);
        //                 let staerke = parseInt(input.radio('staerke'),10);
        //                 let produkt = produkte[staerke];
        //                 this.vsData.setFromProduct(produkt);
        //                 bodenFactory.create(choiceCount);
        //                 APP.model.setDirty();
        //             }
        //         }
        //     ]
        // });
    }

}
